import { exists } from '@/api'

export interface InspectionCheckedCount {
  checkedCount: number
  totalCount: number
}

export const defaultInspectionCheckedCount = (): InspectionCheckedCount => ({
  checkedCount: 0,
  totalCount: 0
})

export function InspectionCheckedCountFromJSON(
  json: any
): InspectionCheckedCount {
  return {
    checkedCount: exists(json, 'checked_count') ? json.checked_count : 0,
    totalCount: exists(json, 'total_count') ? json.total_count : 0
  }
}
